import { defineMessages } from 'react-intl';

export const redeemTabWarningMessages = defineMessages({
  warningBeforeClosingBrowserTab: {
    id: 'src.constants.redeemTabWarningMessages.warningBeforeClosingBrowserTab',
    defaultMessage: 'Leave site? Changes you made may not be saved.',
  },
});
